/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */

import * as types from "./types";

const mutations = {
  [types.RESET_VIEWS](state) {
    state.views = [];
  },

  [types.RESET_ACTIVE_VIEW](state) {
    state.activeView = "";
  },

  [types.NEXT_VIEW](state) {
    const currentView = state.views.indexOf(state.activeView);
    if (currentView > state.views.length) return false;
    state.activeView = state.views[currentView + 1];
    state.stepNumber = state.stepNumber + 1;
  },

  [types.PREV_VIEW](state) {
    const currentView = state.views.indexOf(state.activeView);
    if (currentView < 0) return false;
    state.activeView = state.views[currentView - 1];
    state.stepNumber = state.stepNumber - 1;
  },

  [types.SET_MODELS_STYLE](state, payload) {
    state.modelStyles = payload;
  },

  [types.SET_MODELS_DATA](state, payload) {
    state.modelsData = payload;
  },

  [types.SET_SELECTED_STYLE](state, payload) {
    state.selectedStyle = payload;
  },

  [types.SET_SELECTED_COMBINATION](state, payload) {
    state.selectedCombination = payload;
  },

  [types.SET_SELECTED_SVG_SRC](state, payload) {
    state.selectedSvgSrc = payload;
  },

  [types.SET_SELECTED_PRODUCT_NAME](state, payload) {
    state.selectedProductName = payload;
  },

  [types.RESET_SELECTED_STYLE](state) {
    state.selectedStyle = "";
  },

  [types.SET_COLOR_TILES](state, colorTiles) {
    state.colorTiles = colorTiles;
  },

  [types.SET_ACTIVATE_COLOR_TILES](state, { tileId, value }) {
    state.colorTiles[tileId].active = value;
  },

  [types.RESET_ACTIVATE_COLOR_TILES](state) {
    for (let key in state.colorTiles) {
      state.colorTiles[key].active = "none";
    }
  },

  [types.SET_SELECTED_COLOR](state, payload) {
    let color = Object.keys(state.selectedColors).find(
      key => Number(state.selectedColors[key]) === Number(payload)
    );
    // This color was already selected,
    if (color) {
      // deselect it.
      state.selectedColors[color] = "";
    } else {
      // This color hasn't been selected yet,
      for (let item in state.selectedColors) {
        if (state.selectedColors[item] === "") {
          // add the color ID to the first empty slot in the palette.
          state.selectedColors[item] = payload;
          break;
        }
      }
      // For GTM's dataLayer, increment the tally of changes that the user has made to the color palette.
      state.tallyOfChangesInColorPalette += 1;
    }
  },

  [types.RESET_SELECTED_COLOR](state) {
    for (let key in state.selectedColors) {
      state.selectedColors[key] = "";
    }
  },

  [types.SET_AVAILABLE_SWATCHES](state, swatches) {
    state.available_swatches = swatches;
  },

  [types.SET_STEP_NUMBER](state, payload) {
    state.stepNumber = payload;
  },

  [types.SET_TOTAL_COMBINATIONS](state, payload) {
    state.totalCombinations = payload;
  },

  [types.RESTART_CLICK_COUNT_COLOR_PALETTE](state) {
    state.tallyOfChangesInColorPalette = 0;
  },

  [types.SET_CTA_TILES](state, payload) {
    state.ctaTiles = payload;
  },

  [types.UPDATE_AVAILABLE_SWATCHES](state, {swatchObj}) {
    const index = state.available_swatches.findIndex(el => el.swatch_id === swatchObj.swatch_id);
    if (!!state.available_swatches[index]) {
      state.available_swatches[index] = {
        ...state.available_swatches[index]
      }
    }
  },

  [types.SET_DEFAULT_RECIPE](state, payload) {
    state.defaultRecipe = JSON.parse(JSON.stringify(payload));
  },

  [types.SET_PRODUCT_TYPE](state, { productType = '' }) {
    state.productType = productType;
  },

  [types.SET_SOURCE](state, { source = '' }) {
    state.source = source;
  },
};

export default mutations;
